import React, { useState, useRef, useEffect } from 'react'

import Field from '../../Field/Field'
import TextInput from '../../TextInput/TextInput'
import Textarea from '../../Textarea/Textarea'
import Tooltip from '../../Tooltip/Tooltip'
import FieldLabel from '../../FieldLabel/FieldLabel'
import Checkbox from '../../Checkbox/Checkbox'
import Help from '../../Help/Help'
import { fieldUidRegex, handleToggleClick, NonLocalizableDom } from '../helper'
import ToggleSwitch from '../../ToggleSwitch/ToggleSwitch'
import { booleanTestIdFormatter } from './../../../utils/helpers'

export const Taxonomy = (props: any) => {
  const { onChange, options, parentInfo, uniqueKey, schema, type, isNonLocalizable, hasNonLocalizablePlan, hasNonLocalizablePlanForBlocksAndGroupMultiple } = props
  const [initialSchema, setSchema] = useState(schema)
  const { display_name, uid, field_metadata } = schema
  const [error, setError] = useState(fieldUidRegex(schema.uid, schema))

  const displayNameRef: any = useRef(null)

  useEffect(() => {
    displayNameRef.current.focus()
  }, [displayNameRef])

  const onchange = () => {
    onChange && onChange(schema)
    console.log("🚀 ~ onchange ~ schema:", schema)
    setSchema({ ...schema })
  }
  const onDisplayNameChange = (event: any) => {
    schema.display_name = event.target.value

    // if (schema.hasOwnProperty('display_name') && schema.newfield) {
    //   schema.uid = schema.display_name
    //     .trim()
    //     .replace(/[^A-Z0-9]+/gi, '_')
    //     .toLowerCase()
    //   if (schema.display_name) {
    //     schema.error_details = {
    //       ...schema.error_details,
    //       uid: ''
    //     }
    //   }
    // }

    if (!schema.error_details) {
      schema.error_details = {}
    }

    if (!schema.display_name.length) {
      schema.error_details = {
        ...schema.error_details,
        display_name: 'Display Name cannot be empty'
      }
      schema.error = true
    } else {
      schema.error_details = {
        ...schema.error_details,
        display_name: ''
      }
      schema.error = Object.keys(schema.error_details).filter((fi) => schema.error_details[fi].length).length
        ? true
        : false
    }
    onchange()
  }
  const onUidChange = (event: any) => {
    setError(fieldUidRegex(event.target?.value?.trim(), schema))

    if (!schema.error_details) {
      schema.error_details = {}
    }

    if (!schema.uid.length) {
      schema.error_details = {
        ...schema.error_details,
        uid: 'uid cannot be empty'
      }
      schema.error = true
    } else {
      schema.error_details = {
        ...schema.error_details,
        uid: ''
      }
      schema.error = Object.keys(schema.error_details).filter((fi) => schema.error_details[fi].length).length
        ? true
        : false
    }
    onchange()
  }
  const onHelpTextChange = (event: any) => {
    field_metadata.description = event.target.value
    onchange()
  }
  const onOptionChange = (event: any) => {
    if (event.target.name === `${uniqueKey}.nonLocalization`) {
      if (event.target.checked && parentInfo.hasParent && hasNonLocalizablePlanForBlocksAndGroupMultiple) {
        handleToggleClick(event, parentInfo.data_type, schema, onchange, 'nonLocalizable', props.t , parentInfo.isInsideMultiple ,parentInfo.ancestorWithMultipleType)
      }
      else {
        schema.non_localizable = event.target.checked
      }
    }
    onchange()
  }

  const onInstructionChange = (event: any) => {
    field_metadata.instruction = event.target.value
    onchange()
  }

  if (type === 'basic') {
    return (
      <div className="FormFields">
        <Field>
          <FieldLabel className='FieldLabel__CT' testId='cs-ctf-taxonomy-basic-name-label' version='v2' required htmlFor="displayName">
            Display Name
          </FieldLabel>
          <TextInput
            version='v2'
            required
            name={`${uniqueKey}.displayName`}
            value={display_name}
            onChange={onDisplayNameChange}
            inputRef={displayNameRef}
            error={schema.error && schema.error_details.display_name ? true : false}
            placeholder={props.t(
              'content_type.save_content_type.body.fields.common_properties.placeholders.enter_value'
            )}
            testId='cs-ctf-taxonomy-basic-name'
          />
        </Field>
        <Field>
          <FieldLabel className='FieldLabel__CT' version='v2' testId='cs-ctf-taxonomy-basic-uid-label' required htmlFor="uid">
            Unique ID
          </FieldLabel>
          <Help type="basic" testId='cs-ctf-taxonomy-basic-uid-helptext' text="A unique ID for this field. This should not be same as the ID of any other field in this content type." />
          <TextInput
            required
            version='v2'
            name={`${uniqueKey}.uid`}
            value={uid}
            onChange={onUidChange}
            error={(schema.error && schema.error_details.uid) || error ? true : false}
            placeholder={props.t(
              'content_type.save_content_type.body.fields.common_properties.placeholders.enter_value'
            )}
            disabled={true}
            testId="cs-ctf-taxonomy-basic-uid"
            id="cs-ctf-taxonomy-basic-uid"
          />
        </Field>
        <Field>
          <FieldLabel className='FieldLabel__CT' version='v2' testId='cs-ctf-taxonomy-basic-instruction-label' htmlFor="instruction">Instruction Value</FieldLabel>
          <Help type="basic" text="Helps you add instructions for this field. The instructional text will appear below the field." />
          <Textarea
            version='v2'
            name={`${uniqueKey}.instruction`}
            value={field_metadata.instruction || ''}
            onChange={onInstructionChange}
            placeholder={props.t(
              'content_type.save_content_type.body.fields.common_properties.placeholders.enter_value'
            )}
            testId='cs-ctf-taxonomy-basic-instruction'
            id='cs-ctf-taxonomy-basic-instruction'
          />
        </Field>
        <Field>
          <FieldLabel className='FieldLabel__CT' testId='cs-ctf-taxonomy-basic-help-label' version='v2' htmlFor="helpText">Help Text</FieldLabel>
          <Help type="basic" testId='cs-ctf-taxonomy-basic-helptext' text="Provide additional info about the field. The help text will appear when the user hovers on the ‘?’ sign beside the field name." />
          <Textarea
            version='v2'
            name={`${uniqueKey}.helpText`}
            value={field_metadata.description || ''}
            onChange={onHelpTextChange}
            placeholder={props.t(
              'content_type.save_content_type.body.fields.common_properties.placeholders.enter_value'
            )}
            testId='cs-ctf-taxonomy-basic-help'
            id='cs-ctf-taxonomy-basic-help'
          // multiline={true}
          />
        </Field>

      </div>
    )
  }
  else if (type === 'advanced') {
    return (
      <div className="FormFields">
        {
          hasNonLocalizablePlan ? (
            <div className="FormFields">
              <Field>
                <FieldLabel className='FieldLabel__CT' version="v2" htmlFor="options">Other Options</FieldLabel>
                {
                  hasNonLocalizablePlanForBlocksAndGroupMultiple ? (
                    <NonLocalizableDom
                      isFieldPresent={true}
                      uniqueKey={uniqueKey}
                      schema={schema}
                      onOptionsChange={onOptionChange}
                      dataTestId={booleanTestIdFormatter(schema.nonLocParams?.insideMultiple ? `cs-ct-field-taxonomy-non-localizable-parent-multiple` : `cs-ct-field-taxonomy-non-localizable`, schema.non_localizable)}
                      dataTestIdForDescription={"cs-ct-field-taxonomy-non-localizable-description"}
                      isNonLocalizable={isNonLocalizable}
                      isAncestorNonLoc ={parentInfo.isAncestorNonLoc}
                    />
                  ) : (parentInfo.hasParent ? !parentInfo.isInsideMultiple : true) ?
                    <NonLocalizableDom
                      isFieldPresent={true}
                      uniqueKey={uniqueKey}
                      schema={schema}
                      onOptionsChange={onOptionChange}
                      dataTestId={booleanTestIdFormatter("cs-ct-field-taxonomy-non-localizable", schema.non_localizable)}
                      dataTestIdForDescription={"cs-ct-field-taxonomy-non-localizable-description"}
                      isNonLocalizable={isNonLocalizable}
                      isAncestorNonLoc ={parentInfo.isAncestorNonLoc}
                    />
                    : null
                }
              </Field>
            </div>
          ) : null
        }
      </div>
    )
  }
}

export default React.memo(Taxonomy)
